import React from 'react';

export const Canva = () => (
  <svg
    fill="none"
    height="18px"
    width="18px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1 14a.5.5 0 0 0-.4-.4.4.4 0 0 0-.4.2l-.1.2-.1.2c-.5.7-.8 1-1.7 1.5-.4.2-.9.3-1.3.3-1.3 0-2-1.1-2.3-2.1-.4-1.7.3-3.9 1.3-5.1.5-.7 1-1.1 1.6-1.1a.9.9 0 0 1 .7.4c.3.4.4.8 0 1.4a.5.5 0 0 0 .2.6c.3.1.6 0 1-.5.3-.5.3-1.3 0-1.8-.4-.7-1.2-1-2-1-.7 0-1.3.1-1.8.4a6.8 6.8 0 0 0-2.8 7c.3 1 .8 1.8 1.4 2.3a4 4 0 0 0 2.3.8c1.1 0 2-.4 2.5-.8a5.6 5.6 0 0 0 1.7-1.8l.1-.2a.7.7 0 0 0 .1-.5zm-4.4 3z"
      fill="#fff"
    />
  </svg>
);
